import { useState } from 'react';

import type { GiftPassDetail } from '../../api/gift-passes';

import type { AvailableGiftPassActions, ResendOption } from './gift-pass-actions-model';
import { GiftPassResendModal } from './GiftPassResendModal';
import { GiftPassVoidModal } from './GiftPassVoidModal';

export interface GiftPassActionsProps {
  pass: GiftPassDetail;
  available: AvailableGiftPassActions;
  onChanged: () => void;
}

export function GiftPassActions({ pass, available, onChanged }: GiftPassActionsProps) {
  const [voiding, setVoiding] = useState(false);
  const [resending, setResending] = useState<ResendOption | null>(null);
  const [notice, setNotice] = useState<string | null>(null);

  return (
    <>
      {available.resends.map((option) => (
        <button
          key={option.type}
          type="button"
          className="nb-btn nb-btn-ghost"
          onClick={() => {
            setNotice(null);
            setResending(option);
          }}
        >
          {option.label}
        </button>
      ))}
      {available.canVoid && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          style={{ color: 'var(--nb-risk)', marginLeft: 'auto' }}
          onClick={() => {
            setNotice(null);
            setVoiding(true);
          }}
        >
          Void pass
        </button>
      )}
      {notice && (
        <p role="status" style={{ flexBasis: '100%', margin: 0, fontSize: 12.5 }}>
          {notice}
        </p>
      )}
      {voiding && (
        <GiftPassVoidModal
          passId={pass.id}
          onClose={() => setVoiding(false)}
          onVoided={() => {
            setVoiding(false);
            onChanged();
          }}
        />
      )}
      {resending && (
        <GiftPassResendModal
          passId={pass.id}
          option={resending}
          onClose={() => setResending(null)}
          onSent={(toEmail) => {
            setResending(null);
            setNotice(`Email queued to ${toEmail}.`);
            onChanged();
          }}
        />
      )}
    </>
  );
}
